import React, { useEffect, useState } from 'react';
import ReferralLandingSignupLeft from '../signUp/ReferralLandingSignupLeft';

type Props = {
    referral_code?: string;
    topText: React.ReactNode;
    scrollDown?: () => void;
};

const LandingLeftSection: React.FC<Props> = ({ referral_code, topText, scrollDown }) => {
    const [restart, setRestart] = useState(true);

    useEffect(() => {
        function handleResize() {
            setRestart(!restart);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [restart]);

    return (
        <div
            className={`landing-left h-full ${referral_code ? 'flex' : 'hidden'} md:flex flex-col  min-h-full`}
            style={{ minHeight: `${window.innerHeight}px` }}
        >
            <>
                <ReferralLandingSignupLeft topHtml={topText} scrollDown={scrollDown} restart={restart} />
            </>
        </div>
    );
};
export default LandingLeftSection;
